/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CreaTipoPraticaDaTemplateRequestDTO } from '../model/crea-tipo-pratica-da-template-request-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { TipoPraticaDTO } from '../model/tipo-pratica-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaDaTemplateServiceInterface,
    CreateTipoPraticaDaTemplateRequestParams
} from './tipo-pratica-da-template.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaDaTemplateService extends BaseService implements TipoPraticaDaTemplateServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un TipoPratica da template predefinito (SUPERADMIN)
     * Bootstrap di un nuovo TipoPratica a partire da un template server-side identificato da &#x60;template&#x60; (per ora unico valore: &#x60;MENSA_ESEMPIO&#x60;). Persiste il root e tutti i satelliti strutturali (policy, graduatoria, attributi + valori, gerarchia istituti, eventi/canali comunicazione, configurazione form cittadino) in una singola transazione. Il nuovo TipoPratica e\&#39; sempre creato in stato &#x60;IN_ATTESA&#x60;.  Risposte: - 201: &#x60;TipoPraticaDTO&#x60; del record creato. - 400: payload invalido (template/codice/comune_id mancanti) o comune inesistente. - 403: caller non SUPERADMIN. - 409: codice gia\&#39; usato nel comune target.
     * @endpoint post /api/v1/gestione/tipi-pratica/da-template
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaDaTemplate(requestParameters: CreateTipoPraticaDaTemplateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaDTO>;
    public createTipoPraticaDaTemplate(requestParameters: CreateTipoPraticaDaTemplateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaDTO>>;
    public createTipoPraticaDaTemplate(requestParameters: CreateTipoPraticaDaTemplateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaDTO>>;
    public createTipoPraticaDaTemplate(requestParameters: CreateTipoPraticaDaTemplateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const creaTipoPraticaDaTemplateRequestDTO = requestParameters?.creaTipoPraticaDaTemplateRequestDTO;
        if (creaTipoPraticaDaTemplateRequestDTO === null || creaTipoPraticaDaTemplateRequestDTO === undefined) {
            throw new Error('Required parameter creaTipoPraticaDaTemplateRequestDTO was null or undefined when calling createTipoPraticaDaTemplate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/da-template`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: creaTipoPraticaDaTemplateRequestDTO,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
